const Role = {
  MANAGER_FB: 4,
  MANAGER_INDEP: [1, 2, 3],
}

export const permissions = {
  '/fb': Role.MANAGER_INDEP.concat([Role.MANAGER_FB]),
  '/': Role.MANAGER_INDEP,
}
